/**
 * Returns the last matching index in the array, or -1 if no match is found.
 */
export function findLastIndex<T>(
  array: T[] | null | undefined,
  predicate: (t: T) => boolean,
): number {
  if (!array) return -1;
  for (let i = array.length - 1; i >= 0; i--) {
    if (predicate(array[i])) return i;
  }
  return -1;
}
